import { Base } from '../base';

export class RegisterParkingLot extends Base {
    Prefix?: string;
    Suffix?: string;
    Padding?: number;
    Start?: number;
    End?: number;

    IsSaved = false;
    id = 0;

    // Constructors
    constructor(
        prefix?: string,
        suffix?: string,
        padding?: number,
        start?: number,
        end?: number
    ) {
        super();
        this.Prefix = prefix;
        this.Suffix = suffix;
        this.Padding = padding;
        this.Start = start;
        this.End = end;
    }
}
